module.exports = __webpack_public_path__ + "static/media/21ECLAC7.e453e4c3.jpg";